import { usePathname } from 'next/navigation';

import { EventType } from '@/analytics/types';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';
import { STORE_POP_PATHNAME } from '@/app/consts/pathnames';

const FitnessHero = () => {
  const path = usePathname();

  const handleCtaClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'shop_now',
      action: 'go_to_pdp',
      location: 'hero_module',
      module: 'hero_module',
      path,
    });
  };

  return (
    <LandingPageHero
      backgroundImage={{
        alt: '',
        srcSet: [
          {
            media: '(max-width: 1023px)',
            src: 'fitness/fn-sleep-mobile-hero',
          },
          {
            media: '(min-width: 1024px)',
            src: 'fitness/fn-sleep-desktop-hero',
          },
        ],
      }}
      backgroundProps={{
        color: 'sandstone-200',
        gradients: [],
      }}
      copy="fitness_hero_sub_title_landing"
      eyebrow="fitness"
      cta={{
        href: STORE_POP_PATHNAME,
        label: 'call_to_action_button_text',
        onClick: handleCtaClick,
      }}
      data-cy="fitness-hero"
      title="comparisons_oura_title"
      titleProps={{
        indentation: 'pl-[10rem] md:pl-[15rem] lg:pl-[20rem]',
        typographyProps: {
          className: 'lg:en:whitespace-nowrap',
        },
      }}
      textColor="text-sandstone-200"
    />
  );
};

export default FitnessHero;
